import moment from 'moment';
import React, { useEffect, useState, useRef } from 'react';
import Lottie from 'react-lottie';
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import io from "socket.io-client";
import { Button, Card, FormGroup, Icon, MenuItem, Switch, Menu, Collapse, Position, Popover } from '@blueprintjs/core';
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import { Select, MultiSelect } from "@blueprintjs/select";
import { L10n, loadCldr, setCulture, setCurrencyCode } from '@syncfusion/ej2-base';
import { GridComponent, ColumnDirective, ColumnsDirective, Page, Group, Inject, GroupSettingsModel, Aggregate, Toolbar, ToolbarItems, PdfExport, Grid, Filter, FilterSettingsModel, Reorder, Column, Sort, SortSettingsModel, PdfHeaderQueryCellInfoEventArgs } from "@syncfusion/ej2-react-grids";

import { IconeHome } from '../../Assets';
import polygonsJson from '../../Data/LocalData/Mapa.json';
import pointsJson from '../../Data/LocalData/index.json';
import areasJson from '../../Data/LocalData/areas.json';
import { SignIn as ContextSignIn } from '../../Context';
import { Localization } from '../../Data/Listas';
import { CentroDeCusto, Identificador } from '../../Services/Controllers';
import { Moeda } from '../../Themes/TextFormat';
import { Objeto } from '../../Services/Models';
import { NotificacaoInterna } from '../../Services/Notification';
import * as LottieFiles from '../../Data/Lottie';

import './App.css';
import Map from './leaflet';
import { image } from './image';
import * as Component from './style';
import './style.css';
import viewModel from './viewModel';

interface Store {
    empreendimento: string;
    unidade: string;
    valorUnidade: number;
    torre: string;
    apto: number;
    pavimento: string;
    qtdQuartos: number;
    qtdSemanas: number;
    cota: string;
    observacao: string;
    vista: string;
    id: number;
    status: number;
    unidades: Objeto.Identificador;
    sigla: string;
    lista: Array<Objeto.Identificador>;
    store: Array<Store>;
    categorias: Array<any>;
};

loadCldr(
    require('../../../node_modules/cldr-data/main/pt/currencies.json'),
    require('../../../node_modules/cldr-data/main/pt/numbers.json'),
    require('../../../node_modules/cldr-data/main/pt/ca-gregorian.json'),
    require('../../../node_modules/cldr-data/main/pt/timeZoneNames.json'),
    require('../../../node_modules/cldr-data/supplemental/numberingSystems.json')
);
setCulture('pt');
setCurrencyCode("BRL");
L10n.load(Localization);

var socket: any;
let dataStorage: Array<Store>;
let dataStorageCategorias: any;

const View: React.FC<viewModel> = (viewModel) => {
    /* #region  Variáveis  */
    const [getExibirMapa, setExibirMapa] = useStateWithCallbackLazy<boolean>(false);

    /* #region  Variáveis da tabela de disponibilidade */
    const [getItemPickerCentroDeCusto, setItemPickerCentroDeCusto] = useState<Objeto.CentroDeCusto>();
    const [getListaPickerCentroDeCusto, setListaPickerCentroDeCusto] = useState<Array<Objeto.CentroDeCusto>>([]);
    const PickerCentroDeCusto = Select.ofType<Objeto.CentroDeCusto>();

    const [getListaDeUnidades, setListaDeUnidades] = useState<Array<Objeto.Identificador>>([]);
    const [getListaDeDisponibilidade, setListaDeDisponibilidade] = useState<Array<Store>>([]);
    const [getListaDeCategorias, setListaDeCategorias] = useState<Array<any>>([]);
    const timelineLoaded = useRef<boolean>(false);
    const [getCarregandoListaDeUnidades, setCarregandoListaDeUnidades] = useStateWithCallbackLazy<boolean | undefined>(undefined);
    /* #endregion */

    /* #region  Variáveis do mapa */
    const [getListaDeMarcacoes, setListaDeMarcacoes] = useState<any>();
    /*<{ imagemMapaDoLoteamento: { descricao: string, extensao: string, arquivo: string }, lista: Array<{ quadra: string, lotes: Array<{ lote: string, Posicao: Objeto.CoordenadaGeografica, objeto: Objeto.Identificador }> }>, statusDaInadimplencia: Array<{ descricao: string, cor: string }> }>*/
    const [getListaPontosCentrais, setListaPontosCentrais] = useState<any>();
    const [getListaAreas, setListaAreas] = useState<any>();
    const [getVisaoMapa, setVisaoMapa] = useState<number>(0);
    const [getCarregandoListaDeMarcacoes, setCarregandoListaDeMarcacoes] = useStateWithCallbackLazy<boolean | undefined>(undefined);
    const [getCollapse, setCollapse] = useState(false);

    var Cordenadas: Array<number>;
    /* #endregion */
    /* #endregion */

    useEffect(() => {
        async function componentDidMount() {
            socket = io(String(process.env.REACT_APP_CONNECTION_PORT), { transports: ['websocket', 'polling', 'flashsocket'] })
        }
        componentDidMount();
    }, [process.env.REACT_APP_CONNECTION_PORT]);
    useEffect(() => {
        setListaDeMarcacoes(/*Response.data*/polygonsJson);
        setListaPontosCentrais(pointsJson);
        setListaAreas(areasJson);
        if (!timelineLoaded.current) {
            socket.on("receive_unidade", (data: any) => {
                let IndexUnidades = getListaDeUnidades.findIndex((contrato) => contrato.indice == data.id);
                let IndexDisponibilidade: any = getListaDeDisponibilidade.findIndex((contrato) => contrato.id == data.id);

                if (IndexUnidades >= 0) {
                    let ListaDeUnidades = [...getListaDeUnidades];
                    let ListaDeDisponibilidade = [...getListaDeDisponibilidade];

                    ListaDeUnidades[IndexUnidades] = data.unidade;
                    ListaDeDisponibilidade[IndexDisponibilidade].unidades.status = data.status;

                    timelineLoaded.current = true;
                    setListaDeUnidades(ListaDeUnidades);
                    timelineLoaded.current = false;

                    socket.off('receive_unidade');
                    socket.on('receive_unidade', (data: any) => {
                        let IndexUnidades = getListaDeUnidades.findIndex((contrato) => contrato.indice == data.id);
                        let IndexDisponibilidade: any = getListaDeDisponibilidade.findIndex((contrato) => contrato.id == data.id);

                        if (IndexUnidades >= 0) {
                            let ListaDeUnidades = [...getListaDeUnidades];
                            let ListaDeDisponibilidade = [...getListaDeDisponibilidade];

                            ListaDeUnidades[IndexUnidades] = data.unidade;
                            ListaDeDisponibilidade[IndexDisponibilidade].unidades.status = data.status;

                            timelineLoaded.current = true;
                            setListaDeUnidades(ListaDeUnidades);
                            timelineLoaded.current = false;
                        }
                    });
                }
            })
        }
    }, [getListaDeUnidades])
    const connectToRoom = (room: string | undefined) => {
        socket.emit('join_room', room)
        console.log(`Conectado a sala: ${room}`)
    }
    const sendUnidade = async (unidade: Objeto.Identificador, sigla: string, lista: Array<Objeto.Identificador>, store: Array<Store>) => {
        let UnidadeContent = {
            room: sigla,
            content: {
                id: unidade.indice,
                unidade: unidade,
                status: unidade.status === 2 ? 3 : unidade.status,
            },
        }
        await socket.emit("send_unidade", UnidadeContent);
        socket.off('receive_unidade');
        socket.on('receive_unidade', (data: any) => {
            let Index = (lista).findIndex((contrato: any) => contrato.indice == data.id);
            let IndexStore: any = (store).findIndex((contrato) => contrato.id == data.id);
            let IndexStoreExibido: any = (store).findIndex((contrato) => contrato.id == data.id);

            if (Index >= 0) {
                let ListaDeContratosExibidos = [...lista];
                let UnidadeStore = [...store];
                let UnidadeStoreExibidos = [...store];

                ListaDeContratosExibidos[Index] = data.unidade;
                UnidadeStore[IndexStore].unidades.status = data.status;
                UnidadeStoreExibidos[IndexStoreExibido].unidades.status = data.status;

                timelineLoaded.current = true;
                setListaDeUnidades(ListaDeContratosExibidos);
                timelineLoaded.current = false;
            }
        });
    }

    /* Sobre esta função *//**
     * Calcula o cenário a ser exibido na legenda
     * @param {string} status Informe o status da unidade"
     * @param {string} NivelDeVisualizacao Informe o tipo da operação a ser realizada (1: área, 2: Qtd, 3: valor)"
     **/
    function Calcularcenario(status: number | string | undefined, tipo: number) {
        let total = 0;
        switch (tipo) {
            case 0:
                getListaDeMarcacoes?.lista.map((quadra: any, quadraIndex: any) => {
                    quadra.lotes.map((lote: any, loteIndex: any) => {
                        if ((getVisaoMapa == 0 ? lote.objeto.status : lote.objeto.statusDaInadimplencia) == status) {
                            total += lote.objeto.area;
                        }
                    })
                })
                break;
            case 1:
                getListaDeMarcacoes?.lista.map((quadra: any, quadraIndex: any) => {
                    quadra.lotes.map((lote: any, loteIndex: any) => {
                        if ((getVisaoMapa == 0 ? lote.objeto.status : lote.objeto.statusDaInadimplencia) == status) {
                            total += 1;
                        }
                    })
                })
                break;
            case 2:
                getListaDeMarcacoes?.lista.map((quadra: any, quadraIndex: any) => {
                    quadra.lotes.map((lote: any, loteIndex: any) => {
                        if ((getVisaoMapa == 0 ? lote.objeto.status : lote.objeto.statusDaInadimplencia) == status) {
                            total += lote.objeto.valorAVista;
                        }
                    })
                })
                break;
        }

        return total;
    }
    /* Sobre esta função *//**
       * Calcula o cenário a ser exibido na legenda
       * @param {number} longitude Informe a longitude do marcador"
       * @param {number} latitude Informe a latitude do marcador"
       **/
    function CalcularCoordenadasDoMarcador(longitude: number, latitude: number) {
        let origem: Array<number> = [38.231544, -122.400049];
        let escalaM: number = 24 / 2;
        let contaLong: number = -1 * ((longitude - origem[0]) * (111.11 * 1000)) / escalaM;
        let contaLat: number = ((latitude - origem[1]) * (111.11 * 1000)) / escalaM;
        Cordenadas = [contaLat, contaLong];
    }
    /* Sobre esta função *//**
       * Executa todas as rotinas atrealadas a alteração do centro de custo exibido na página
       * @param {Objeto.CentroDeCusto | undefined} Item Informe o objeto referente ao centro de custo
       * @param {MapaExibido} MapaExibido Informe se o mapa está exibido (condição necessária por causa do delay do usestate)
       **/
    async function SelecionarCentroDeCusto(Item: Objeto.CentroDeCusto | undefined, MapaExibido: boolean) {
        if (MapaExibido) {
            if (Item) {
                await setCarregandoListaDeMarcacoes(false, async () => {
                    await setItemPickerCentroDeCusto(Item);

                    var Response = await Identificador.Get3(ContextSignIn.getContext().token, Item?.empresa.id ?? 0, Item?.sigla ?? "");
                    if (Math.floor(Response.status / 100) == 2) {
                        await setListaDeMarcacoes(/*Response.data*/polygonsJson);
                        await setListaPontosCentrais(pointsJson);
                        // Response.data.lista?.map((quadra, quadraIndex) => {
                        //     quadra.lotes.map((lote, loteIndex) => {
                        //         CalcularCoordenadasDoMarcador(lote.objeto.centro.longitude, lote.objeto.centro.latitude);
                        //         lote.Posicao = { latitude: Cordenadas[1], longitude: Cordenadas[0] };
                        //     });
                        // });
                        await setCarregandoListaDeMarcacoes(true, () => { });
                    }
                    else {
                        await setCarregandoListaDeMarcacoes(undefined, () => { });
                        await setListaDeMarcacoes(undefined);
                        await setListaPontosCentrais(undefined);
                        NotificacaoInterna.ExibirNotificacao("Falha ao gerar o mapa", "Infelizmente o empreendimento selecionado ainda não possui um mapa vinculado!, entre em contato com a equipe de desenvolvimento", NotificacaoInterna.TipoDeNotificacao.Erro);
                    }
                });
            }
        }
        else {
            await setCarregandoListaDeUnidades(false, async () => {
                if (Item) {
                    await setItemPickerCentroDeCusto(Item);
                    connectToRoom(Item.sigla)

                    let Response = (await Identificador.Get(ContextSignIn.getContext().token, Item.empresa.id ?? 0, Item.sigla ?? ""));
                    let ResponseCategorias = (await Identificador.CategoriasDeReserva(ContextSignIn.getContext().token, Item.empresa.id ?? 0, Item.sigla ?? ""));

                    if (Math.floor(Response.status / 100) == 2) {
                        dataStorage = [];

                        Response.data.filter((Item) => Item.status == 0 || (Item.status == 2 && Item.reservaVinculada.vendedorId == ContextSignIn.getContext().pessoa.id)).map((contrato, Index) => {
                            contrato.observacoes.map((obs, obsIndex) => {
                                obs.substring(obs.indexOf(":"))
                            })
                            dataStorage.push(
                                {
                                    empreendimento: `${contrato.centroDeCusto.descricao}`,
                                    unidade: `${contrato.subLocal.descricao}`,
                                    torre: `${(contrato.observacoes.find((item) => item.includes("Torre: ")) ?? "").substring((contrato.observacoes.find((item) => item.includes("Torre: ")) ?? "").indexOf(": ") + 2)}`,
                                    apto: parseInt((contrato.observacoes.find((item) => item.includes("Apartamento: ")) ?? "").substring((contrato.observacoes.find((item) => item.includes("Apartamento: ")) ?? "").indexOf(": ") + 2)),
                                    pavimento: `${(contrato.observacoes.find((item) => item.includes("Pavimento: ")) ?? "").substring((contrato.observacoes.find((item) => item.includes("Pavimento: ")) ?? "").indexOf(": ") + 2)}`,
                                    qtdQuartos: parseInt((contrato.observacoes.find((item) => item.includes("Qtde. de quartos: ")) ?? "").substring((contrato.observacoes.find((item) => item.includes("Qtde. de quartos: ")) ?? "").indexOf(": ") + 2)),
                                    qtdSemanas: parseInt((contrato.observacoes.find((item) => item.includes("Qtde. de semanas: ")) ?? "").substring((contrato.observacoes.find((item) => item.includes("Qtde. de semanas: ")) ?? "").indexOf(": ") + 2)),
                                    valorUnidade: contrato.valorAVista,
                                    cota: `${(contrato.observacoes.find((item) => item.includes("Cota: ")) ?? "").substring((contrato.observacoes.find((item) => item.includes("Cota: ")) ?? "").indexOf(": ") + 2)}`,
                                    observacao: `${(contrato.observacoes.find((item) => item.includes("Observação: ")) ?? "").substring((contrato.observacoes.find((item) => item.includes("Observação: ")) ?? "").indexOf(": ") + 2)}`,
                                    vista: `${(contrato.observacoes.find((item) => item.includes("Vista: ")) ?? "").substring((contrato.observacoes.find((item) => item.includes("Vista: ")) ?? "").indexOf(": ") + 2)}`,
                                    id: contrato.indice,
                                    status: contrato.status,
                                    unidades: contrato,
                                    sigla: Item.sigla,
                                    lista: Response.data.filter((Item) => Item.status == 0 || (Item.status == 2 && Item.reservaVinculada.vendedorId == ContextSignIn.getContext().pessoa.id)),
                                    store: [],
                                    categorias: [],
                                }
                            )
                        })

                        dataStorage.map((item, index) => {
                            item.store = dataStorage
                        })
                        await setListaDeDisponibilidade((dataStorage));
                        await setListaDeUnidades(Response.data.filter((Item) => Item.status == 0 || (Item.status == 2 && Item.reservaVinculada.vendedorId == ContextSignIn.getContext().pessoa.id)));
                        await setCarregandoListaDeUnidades(true, () => { });
                    }
                    else {
                        await setItemPickerCentroDeCusto(undefined);
                        await setListaDeUnidades([]);
                        await setListaDeDisponibilidade(([]));
                        await setCarregandoListaDeUnidades(undefined, () => { });
                    }
                    if (Math.floor(ResponseCategorias.status / 100) == 2) {
                        dataStorageCategorias = [];

                        ResponseCategorias.data.map((Item: any) => {
                            dataStorageCategorias.push({
                                Empreendimento: Item.centroDeCusto.descricao,
                                Descricao: Item.descricao,
                                Sigla: Item.sigla,
                                Tempo: Item.tempo
                            })
                        })

                        dataStorage.map((item, index) => {
                            item.categorias = dataStorageCategorias
                        })

                        await setListaDeCategorias(dataStorageCategorias);
                    }
                    else {
                        await setItemPickerCentroDeCusto(undefined);
                        await setListaDeUnidades([]);
                        await setListaDeDisponibilidade(([]));
                        await setListaDeCategorias([]);
                        await setCarregandoListaDeUnidades(undefined, () => { });
                    }
                }
                else {
                    await setItemPickerCentroDeCusto(undefined);
                    await setListaDeUnidades([]);
                    await setListaDeDisponibilidade(([]));
                    await setListaDeCategorias([]);
                    await setCarregandoListaDeMarcacoes(undefined, () => { });
                }
            });

        }
    }
    useEffect(() => {
        async function componentDidMount() {
            await setListaPickerCentroDeCusto((await CentroDeCusto.Get(ContextSignIn.getContext().token, "VENDA")).data ?? []);
        }
        componentDidMount();
    }, []);

    const toolbarOptions: ToolbarItems[] = ['PdfExport']

    const groupOptions: GroupSettingsModel = {
        showGroupedColumn: true,
        showUngroupButton: true,
    }

    const filterOptions: FilterSettingsModel = {
        ignoreAccent: true,
        immediateModeDelay: 200,
        mode: "Immediate",
        type: 'Excel',
    }

    const sortOptions: SortSettingsModel = {

    }

    const pdfHeaderQueryCellInfo = (args: PdfHeaderQueryCellInfoEventArgs | any) => {
        (args.cell as any).row.pdfGrid.repeatHeader = true;
        args.cell.gridRow.pdfGrid.columns.getColumn(0).width = 100;
        args.cell.gridRow.pdfGrid.columns.getColumn(0).textAlign = "Left";
        args.cell.gridRow.pdfGrid.columns.getColumn(1).width = 100;
        args.cell.gridRow.pdfGrid.columns.getColumn(1).textAlign = "Left";
        args.cell.gridRow.pdfGrid.columns.getColumn(2).width = 60;
        args.cell.gridRow.pdfGrid.columns.getColumn(2).textAlign = "Left";
        args.cell.gridRow.pdfGrid.columns.getColumn(3).width = 40;
        args.cell.gridRow.pdfGrid.columns.getColumn(3).textAlign = "Left";
        args.cell.gridRow.pdfGrid.columns.getColumn(4).width = 80;
        args.cell.gridRow.pdfGrid.columns.getColumn(4).textAlign = "Left";
        args.cell.gridRow.pdfGrid.columns.getColumn(5).width = 50;
        args.cell.gridRow.pdfGrid.columns.getColumn(5).textAlign = "Left";
        args.cell.gridRow.pdfGrid.columns.getColumn(6).width = 50;
        args.cell.gridRow.pdfGrid.columns.getColumn(6).textAlign = "Left";
        args.cell.gridRow.pdfGrid.columns.getColumn(7).width = 90;
        args.cell.gridRow.pdfGrid.columns.getColumn(7).textAlign = "Left";
    }

    let grid: Grid | null;
    const toolbarClick = (args: any) => {
        if (grid) {
            if (args.item.id === 'grid_pdfexport') {
                (grid.columns[9] as Column).visible = false;
                grid.pdfExport({
                    fileName: `Disponibilidade ${moment(new Date(), true).format("YYYY-MM-DD")} - ${((getItemPickerCentroDeCusto?.empresa.id == 20) ? "PRE" : ((getItemPickerCentroDeCusto?.empresa.id == 21) ? "SPR" : ((getItemPickerCentroDeCusto?.empresa.id == 22) ? "SER" : ((getItemPickerCentroDeCusto?.empresa.id == 23) ? "PAR" : (getItemPickerCentroDeCusto?.empresa.id == 26 ? "PYR" : getItemPickerCentroDeCusto?.sigla)))))}.pdf`,
                    pageOrientation: "Landscape",
                    header: {
                        fromTop: 0,
                        height: 100,
                        contents: [
                            {
                                type: 'Text',
                                value: `${getItemPickerCentroDeCusto?.descricao}`,
                                position: { x: 390, y: 50 },
                                style: { textBrushColor: "#000000", fontSize: 20, hAlign: "Right" },
                            },
                            {
                                position: { x: 0, y: 45 },
                                size: { height: 40, width: 80 },
                                src: image,
                                type: 'Image',
                            },
                            {
                                type: 'Text',
                                value: `${moment(new Date(), true).format("DD/MM/YYYY HH:MM:SS")}`,
                                position: { x: 880, y: 55 },
                                style: { textBrushColor: "#000000", fontSize: 13 },
                            },
                        ],
                    },
                    footer: {
                        contents: [
                            {
                                type: 'Text',
                                value: `Powered by DigitalDEV`,
                                position: { x: 0, y: 0 },
                                style: { textBrushColor: "#000000", fontSize: 10 },
                            },
                            {
                                format: 'Página {$current} de {$total}',
                                pageNumberType: "Numeric",
                                position: { x: 910, y: 0 },
                                style: {
                                    fontSize: 13,
                                    hAlign: "Right",
                                    textBrushColor: '#000000',
                                },
                                type: 'PageNumber',
                            }
                        ],
                        fromBottom: 0,
                        height: 20,
                    },
                    theme: {
                        header: {
                            bold: true,
                            fontColor: "#000000",
                            fontSize: 8,
                        },
                        record: {
                            bold: false,
                            fontColor: "#000000",
                            fontSize: 8,
                        },
                        caption: {
                            bold: true,
                            fontColor: "#000000",
                            fontSize: 8,
                        }
                    },
                    allowHorizontalOverflow: false,
                });
            }
        }
    }

    const pdfExportComplete = () => {
        if (grid) {
            (grid.columns[9] as Column).visible = true;
        }
    }

    const templateBotao = (props: any) => (
        <>
            {props.categorias.length > 0 && props.unidades.status == 0 && <Popover content={
                <Menu>
                    <MenuItem icon="list" text="Categorias...">
                        {props.categorias.map((item: any, index: number) => (
                            <>
                                <MenuItem icon="symbol-circle" text={`${item.Descricao}`}
                                    onClick={async () => {
                                        if (props.unidades?.status === 0) {
                                            if (!props.unidades._ReservandoUnidade) {
                                                let ListaDeContratosExibidos = [...props.lista];
                                                props.unidades._ReservandoUnidade = true;
                                                await setListaDeUnidades(ListaDeContratosExibidos);
                                                NotificacaoInterna.ExibirNotificacao("Reserva sendo gerada", "Por favor, aguarde a finalização do processo, ele pode demorar devido a integração com sistemas externos", NotificacaoInterna.TipoDeNotificacao.Informacao);
                                            }
                                            else {
                                                return;
                                            }
                                            let Response = await Identificador.ReservarUnidadesComTimer(ContextSignIn.getContext().token, item.Tempo, [props.unidades]);
                                            let ListaDeContratosExibidos = [...props.lista];
                                            props.unidades._ReservandoUnidade = ((Math.floor(Response.status / 100) == 2) ? false : undefined);
                                            props.unidades.status = ((Math.floor(Response.status / 100) == 2) ? 2 : 0);
                                            await setListaDeUnidades(ListaDeContratosExibidos);
                                            if (Math.floor(Response.status / 100) == 2) {
                                                sendUnidade(props.unidades, props.sigla, props.lista, props.store);
                                                NotificacaoInterna.ExibirNotificacao("Reserva realizada com sucesso", "Sua unidade já se encontra reservada em todos os sitemas", NotificacaoInterna.TipoDeNotificacao.Sucesso);
                                            }
                                            else {
                                                NotificacaoInterna.ExibirNotificacao("Falha ao gerar a reserva", "Entre em contato com o desenvolvimento do sistema", NotificacaoInterna.TipoDeNotificacao.Erro);
                                            }
                                        }
                                        else if (props.unidades?.status === 2) {
                                            if (!props.unidades._DeletandoReserva) {
                                                let ListaDeContratosExibidos = [...props.lista];
                                                props.unidades._DeletandoReserva = true;
                                                await setListaDeUnidades(ListaDeContratosExibidos);
                                                NotificacaoInterna.ExibirNotificacao("Disponibilizando unidade", "Por favor, aguarde a finalização do processo, ele pode demorar devido a integração com sistemas externos", NotificacaoInterna.TipoDeNotificacao.Informacao);
                                            }
                                            else {
                                                return;
                                            }
                                            let Response = await Identificador.DeletarReservas(ContextSignIn.getContext().token, [props.unidades]);
                                            let ListaDeContratosExibidos = [...props.lista];
                                            props.unidades._DeletandoReserva = ((Math.floor(Response.status / 100) == 2) ? false : undefined);
                                            props.unidades.status = ((Math.floor(Response.status / 100) == 2) ? 0 : 2);
                                            await setListaDeUnidades(ListaDeContratosExibidos);

                                            if (Math.floor(Response.status / 100) == 2) {
                                                sendUnidade(props.unidades, props.sigla, props.lista, props.store);
                                                NotificacaoInterna.ExibirNotificacao("Unidade disponibilizada com sucesso", "Sua unidade já se encontra disponível em todos os sitemas", NotificacaoInterna.TipoDeNotificacao.Sucesso);
                                            }
                                            else {
                                                NotificacaoInterna.ExibirNotificacao("Falha ao diponibilizar a unidade", "Entre em contato com o desenvolvimento do sistema", NotificacaoInterna.TipoDeNotificacao.Erro);
                                            }
                                        }
                                    }} />
                            </>
                        ))}
                    </MenuItem>
                </Menu>
            } position={Position.BOTTOM_RIGHT}>
                <Button
                    disabled={props.unidades.status === 3 ? true : false}
                    intent={props.unidades.status === 2 ? 'success' : 'danger'}
                    style={{ height: "5px", width: "8vw", borderRadius: '5px', cursor: "pointer", outline: "none", display: "flex", padding: "0" }}
                ><Icon iconSize={(document.documentElement.clientWidth / 100) - 4} style={{ marginBottom: "4px" }} icon={(props.unidades.status === 2 || props.unidades.status === 3) ? "unlock" : "lock"} />
                    <strong style={{ fontSize: "0.8vw" }}>{props.unidades.status === 2 ? ' Disponibilizar' : (props.unidades.status === 3 ? 'Reservado' : ' Reservar')}</strong>
                </Button>
            </Popover>}
            {(props.categorias.length == 0 || (props.categorias.length > 0 && (props.unidades.status === 3 || props.unidades.status === 2))) && <Button
                disabled={props.unidades.status === 3 ? true : false}
                intent={props.unidades.status === 2 ? 'success' : 'danger'}
                style={{ height: "5px", width: "8vw", borderRadius: '5px', cursor: "pointer", outline: "none", display: "flex", padding: "0" }}
                onClick={async () => {
                    if (props.unidades?.status === 0) {
                        if (!props.unidades._ReservandoUnidade) {
                            let ListaDeContratosExibidos = [...props.lista];
                            props.unidades._ReservandoUnidade = true;
                            await setListaDeUnidades(ListaDeContratosExibidos);
                            NotificacaoInterna.ExibirNotificacao("Reserva sendo gerada", "Por favor, aguarde a finalização do processo, ele pode demorar devido a integração com sistemas externos", NotificacaoInterna.TipoDeNotificacao.Informacao);
                        }
                        else {
                            return;
                        }
                        let Response = await Identificador.ReservarUnidades(ContextSignIn.getContext().token, [props.unidades]);
                        let ListaDeContratosExibidos = [...props.lista];
                        props.unidades._ReservandoUnidade = ((Math.floor(Response.status / 100) == 2) ? false : undefined);
                        props.unidades.status = ((Math.floor(Response.status / 100) == 2) ? 2 : 0);
                        await setListaDeUnidades(ListaDeContratosExibidos);
                        if (Math.floor(Response.status / 100) == 2) {
                            sendUnidade(props.unidades, props.sigla, props.lista, props.store);
                            NotificacaoInterna.ExibirNotificacao("Reserva realizada com sucesso", "Sua unidade já se encontra reservada em todos os sitemas", NotificacaoInterna.TipoDeNotificacao.Sucesso);
                        }
                        else {
                            NotificacaoInterna.ExibirNotificacao("Falha ao gerar a reserva", "Entre em contato com o desenvolvimento do sistema", NotificacaoInterna.TipoDeNotificacao.Erro);
                        }
                    }
                    else if (props.unidades?.status === 2) {
                        if (!props.unidades._DeletandoReserva) {
                            let ListaDeContratosExibidos = [...props.lista];
                            props.unidades._DeletandoReserva = true;
                            await setListaDeUnidades(ListaDeContratosExibidos);
                            NotificacaoInterna.ExibirNotificacao("Disponibilizando unidade", "Por favor, aguarde a finalização do processo, ele pode demorar devido a integração com sistemas externos", NotificacaoInterna.TipoDeNotificacao.Informacao);
                        }
                        else {
                            return;
                        }
                        let Response = await Identificador.DeletarReservas(ContextSignIn.getContext().token, [props.unidades]);
                        let ListaDeContratosExibidos = [...props.lista];
                        props.unidades._DeletandoReserva = ((Math.floor(Response.status / 100) == 2) ? false : undefined);
                        props.unidades.status = ((Math.floor(Response.status / 100) == 2) ? 0 : 2);
                        await setListaDeUnidades(ListaDeContratosExibidos);

                        if (Math.floor(Response.status / 100) == 2) {
                            sendUnidade(props.unidades, props.sigla, props.lista, props.store);
                            NotificacaoInterna.ExibirNotificacao("Unidade disponibilizada com sucesso", "Sua unidade já se encontra disponível em todos os sitemas", NotificacaoInterna.TipoDeNotificacao.Sucesso);
                        }
                        else {
                            NotificacaoInterna.ExibirNotificacao("Falha ao diponibilizar a unidade", "Entre em contato com o desenvolvimento do sistema", NotificacaoInterna.TipoDeNotificacao.Erro);
                        }
                    }
                }}><Icon iconSize={(document.documentElement.clientWidth / 100) - 4} style={{ marginBottom: "4px" }} icon={(props.unidades.status === 2 || props.unidades.status === 3) ? "unlock" : "lock"} />
                <strong style={{ fontSize: "0.8vw" }}>{props.unidades.status === 2 ? ' Disponibilizar' : (props.unidades.status === 3 ? 'Reservado' : ' Reservar')}</strong>
            </Button>}
        </>
    );

    return (
        <Component.Container>
            <Collapse isOpen={getCollapse}>
                <div className="endereco">
                    <img src={IconeHome} alt="" />
                    <div className="bar">/</div>
                    <div className="place">Disponibilidade</div>
                    <div className="bar">/</div>

                    <PickerCentroDeCusto disabled={true} popoverProps={{ popoverClassName: "bp3-multi-select-popover" }} items={getListaPickerCentroDeCusto} onItemSelect={() => { }} noResults={<MenuItem style={{ position: "relative", zIndex: 20000 }} disabled={true} text="Sem resultados disponíveis" />}
                        itemRenderer={(Item: Objeto.CentroDeCusto) => <MenuItem style={{ position: "relative", zIndex: 90000 }} onClick={async () => { await SelecionarCentroDeCusto(Item, getExibirMapa); }} text={Item.descricao} />} itemPredicate={(Texto: string, Item: Objeto.CentroDeCusto) => { return (Item.descricao ?? "").toUpperCase().includes(Texto.toUpperCase()) || Texto == "" }}>
                        <Button disabled={true} className="selector" style={{ background: "#ffffff", position: "relative", zIndex: 90000, color: "#13455e", border: "none", boxShadow: "none", borderRadius: "5px", outline: "none", width: "150px", display: "flex", alignItems: "center", justifyContent: "space-between", marginRight: "20px" }} text={getItemPickerCentroDeCusto?.descricao.substring(0, 10).concat("...") ?? /*"Empreendimento"*/"RESIDENCIAL ESPLANADA V - CHAPADAO".substring(0, 10).concat("...")} rightIcon="double-caret-vertical" />
                    </PickerCentroDeCusto>

                    <div style={{ fontWeight: (getExibirMapa == true ? "lighter" : "bolder") }} className="place">Tabela de disponibilidade</div>
                    <Switch style={{ marginLeft: "15px", marginTop: "10px" }} checked={getExibirMapa} onChange={async () => {
                        await setExibirMapa(!getExibirMapa, async () => {
                            await SelecionarCentroDeCusto(getItemPickerCentroDeCusto, !getExibirMapa);
                        });
                    }} />
                    <div style={{ fontWeight: (getExibirMapa == true ? "bolder" : "lighter") }} className="place">Mapa do empreendimento</div>

                    <div style={{ cursor: "pointer", display: getExibirMapa ? "flex" : "none", fontSize: "14px", marginLeft: "auto", width: "600px", height: "30px", background: "0", fontWeight: 500, transition: "width 1.5s" }}>
                        <div onClick={() => setVisaoMapa(0)} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 2%", borderTopLeftRadius: "5px", borderRight: "1px solid #dbdbdb", borderBottomLeftRadius: "5px", width: "25%", height: "100%", cursor: "pointer", visibility: "visible", opacity: "1", background: getVisaoMapa === 0 ? "#99acff" : "white", color: getVisaoMapa === 0 ? "#ffffff" : "#000000", transition: "background-color 1s, visibility 2s, opacity 5s, color 1s" }}>
                            <Icon icon="path-search" />
                            <span style={{ pointerEvents: "none" }}>Disponibilidade</span>
                        </div>
                        <div onClick={() => setVisaoMapa(1)} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 3%", width: "25%", height: "100%", cursor: "pointer", visibility: "visible", opacity: "1", background: getVisaoMapa === 1 ? "#99acff" : "white", color: getVisaoMapa === 1 ? "#ffffff" : "#000000", transition: "background-color 1s, visibility 2s, opacity 5s, color 1s" }}>
                            <Icon icon="dollar" />
                            <span style={{ pointerEvents: "none" }}>Inadimplência</span>
                        </div>
                        <div onClick={() => setVisaoMapa(2)} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 4%", borderLeft: "1px solid #dbdbdb", width: "25%", height: "100%", cursor: "pointer", visibility: "visible", opacity: "1", background: getVisaoMapa === 2 ? "#99acff" : "white", color: getVisaoMapa === 2 ? "#ffffff" : "#000000", transition: "background-color 1s, visibility 2s, opacity 5s, color 1s" }}>
                            <Icon icon="double-caret-horizontal" />
                            <span style={{ pointerEvents: "none" }}>Faixas Preço</span>
                        </div>
                        <div onClick={() => setVisaoMapa(3)} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 4%", borderTopRightRadius: "5px", borderLeft: "1px solid #dbdbdb", borderBottomRightRadius: "5px", width: "25%", height: "100%", cursor: "pointer", visibility: "visible", opacity: "1", background: getVisaoMapa === 3 ? "#99acff" : "white", color: getVisaoMapa === 3 ? "#ffffff" : "#000000", transition: "background-color 1s, visibility 2s, opacity 5s, color 1s" }}>
                            <Icon icon="comparison" />
                            <span style={{ pointerEvents: "none" }}>Categorias</span>
                        </div>
                    </div>
                </div>
            </Collapse>
            {/* Abridor Colapse */}
            <div style={{ width: "100%", height: "20px", backgroundColor: "#ffffff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={() => getCollapse === true ? setCollapse(false) : setCollapse(true)}>
                <Lottie
                    options={{
                        loop: true,
                        autoplay: true,
                        animationData: LottieFiles.SwipeDown,
                        rendererSettings: {
                            preserveAspectRatio: "xMidYMid slice"
                        }
                    }}
                    height={30}
                    width={30}
                    style={getCollapse ? { transform: `rotate(180deg)`, transition: "transform 0.5s" } : { transform: `rotate(0deg)`, transition: "transform 0.5s" }}
                />
            </div>

            {getExibirMapa == false && <div>
                {getCarregandoListaDeUnidades != true && <div style={{ width: "100%", background: "0", display: "flex", flexDirection: "column" }}>
                    <Lottie
                        options={{
                            loop: true,
                            autoplay: true,
                            animationData: LottieFiles.LoadMaps,
                            rendererSettings: {
                                preserveAspectRatio: "xMidYMid slice"
                            }
                        }}
                        height={500}
                        width={500}
                        style={{ marginTop: "122px" }}
                    />
                    <div className="loading" style={{ margin: "-100px auto 0 auto", fontWeight: "bold" }}>{(getCarregandoListaDeUnidades == undefined) ? "Por favor, selecione um empreendimento para exibir a tabela de disponibilidade" : ((getCarregandoListaDeUnidades == false) ? "Aguarde, estamos carregando seu empreendimento" : "Pronto, sua tabela de disponibilidade será exibida!")}</div>
                </div>}
                {getCarregandoListaDeUnidades == true && <Card style={{ backgroundColor: "0", width: "100%", margin: "0px auto 40px auto", padding: "0", borderRadius: "5px", border: "none", boxShadow: "none" }}>
                    {true &&
                        <div style={{ maxWidth: "100%" }}>
                            <GridComponent
                                id='grid'
                                dataSource={getListaDeDisponibilidade}
                                ref={g => grid = g}
                                allowPaging={true}
                                allowGrouping={true}
                                allowPdfExport={true}
                                allowFiltering={true}
                                allowReordering={true}
                                allowSorting={false}
                                sortSettings={sortOptions}
                                toolbar={toolbarOptions}
                                pdfHeaderQueryCellInfo={pdfHeaderQueryCellInfo}
                                toolbarClick={toolbarClick}
                                groupSettings={groupOptions}
                                filterSettings={filterOptions}
                                actionBegin={
                                    (args: any) => {
                                        if (args.requestType === "filterchoicerequest" || args.requestType === 'filtersearchbegin') {
                                            args.filterChoiceCount = 100000;
                                        }
                                    }
                                }
                                pdfExportComplete={pdfExportComplete}
                                pageSettings={{ pageSizes: [20, 50, 100], pageSize: 20 }}
                                locale={"pt"}
                                currencyCode={"BRL"}
                            >
                                <ColumnsDirective>
                                    <ColumnDirective field='unidade' headerText='Unidade' textAlign='Left' isPrimaryKey={true} />
                                    <ColumnDirective field='torre' headerText='Torre' textAlign='Left' />
                                    <ColumnDirective field='pavimento' headerText='Pavimento' textAlign='Left' />
                                    <ColumnDirective field='apto' headerText='Apto' textAlign='Left' />
                                    <ColumnDirective field='valorUnidade' headerText='Valor unidade' textAlign='Left' format='C2' />
                                    <ColumnDirective field='qtdQuartos' headerText='Quartos' textAlign='Left' />
                                    <ColumnDirective field='qtdSemanas' headerText='Semanas' textAlign='Left' />
                                    <ColumnDirective field='vista' headerText='Vista' textAlign='Left' />
                                    <ColumnDirective field='observacao' headerText='Descrição' textAlign='Left' />
                                    <ColumnDirective headerText='' textAlign='Center' template={templateBotao} />
                                </ColumnsDirective>
                                <Inject services={[Page, Group, Toolbar, PdfExport, Aggregate, Filter, Reorder, Sort]} />
                            </GridComponent>
                        </div>
                    }
                </Card>}
            </div>}
            {getExibirMapa == true &&   
                <div onClick={() => setCollapse(false) } style={{ height: "calc(100% - 20px)" }}>
                    {/*getCarregandoListaDeMarcacoes !== true*/!getExibirMapa && <div style={{ width: "100%", background: "0", display: "flex", flexDirection: "column" }}>
                        <Lottie
                            options={{
                                loop: true,
                                autoplay: true,
                                animationData: LottieFiles.LoadMaps,
                                rendererSettings: {
                                    preserveAspectRatio: "xMidYMid slice"
                                }
                            }}
                            height={500}
                            width={500}
                            style={{ marginTop: "200px" }}
                        />
                        <div className="loading" style={{ margin: "-100px auto 0 auto", fontWeight: "bold" }}>{(getCarregandoListaDeMarcacoes == undefined) ? "Por favor, selecione um empreendimento para exibir o mapa" : ((getCarregandoListaDeMarcacoes == false) ? "Aguarde, estamos carregando seu empreendimento" : "Pronto, seu mapa logo será exibido!")}</div>
                    </div>}
                    {/*getCarregandoListaDeMarcacoes ===*/ true && <Map visao={getVisaoMapa} polygons={getListaDeMarcacoes} areas={getListaAreas} points={getListaPontosCentrais} />}
                </div>}
        </Component.Container >
    );
    /* #endregion */
};

export default View;